import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Layout } from './utility/context/Layout';
import { store } from './lib/store/store';
import Loader from './assets/img/gif/Saurbhi_Loader.gif';
import './index.scss';
import './@fake-db';

const LazyApp = lazy(() => import('./App'));

ReactDOM.render(
    <Provider store={store}>
        <Suspense
            fallback={
                <div id="loading">
                    <div className="loader-content position-relative">
                        <img src={Loader} className="loading-image" alt="" />
                    </div>
                </div>
            }
        >
            <Layout>
                <LazyApp />
            </Layout>
        </Suspense>
    </Provider>,
    document.getElementById('root'),
);
